import { useState, useEffect } from "react";
import Clock from "../../components/Clock";
import search from "/assets/icon/Search.svg";
import filter from "/assets/icon/Filter.svg";
import Layer from "/Layer1.png?url";
import "./styles/Wildlife.css";
import Map from "../../components/Map";
import eye from "/assets/Eye.png";
import UserStatus from "../../components/UserStatus";
import Detail from "../../components/Detail";
import Lamp from "/assets/lamp.png";
function Wildlife() {
  const [activeDetail, setActiveDetail] = useState(null);

  const handleDetailClick = (row) => {
    setActiveDetail(row);
  };

  const handleCloseDetail = () => {
    setActiveDetail(null);
  };

  const tableData = [
    {
      no: 1,
      stationCode: "A254006",
      stationName: "ศูนย์อุตุนิยมวิทยา",
      coordinates: "13.813,100.077",
      signalDetection: "ปกติ",
    },
    {
      no: 2,
      stationCode: "A254006",
      stationName: "ศูนย์อุตุนิยมวิทยา",
      coordinates: "13.813,100.077",
      signalDetection: "ปกติ",
    },
    // ... more data rows
  ];
  return (
    <div className="containerPage">
      <div className="sections1">
        <h1>ตรวจจับสัตว์ป่า</h1>
        <h2>
          <Clock />
        </h2>
      </div>

      <div className="sections2">
        <div className="area-chart-container">
            <img src={Lamp} alt="Lamp" className="Lamp" />
          <div className="titleanimal">
            {" "}
            <img src={Layer} alt="Layer" />
          </div>
          <div className="detailanimal"></div>
        </div>

        <div className="areaMap">
          <Map />
        </div>
      </div>
      <div className="section3">
        <div className="led-section">
          <div className="search-bar">
            <img src={search} alt="search" className="search-user" />
            <input
              type="text"
              placeholder="ค้นหาชื่อ, หมายเลขโทรศัพท์, หรืออีเมล"
            />
            <div>
              <img src={filter} alt="filter" className="filter-user" />
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>รหัสเสา</th>
                <th>ชื่อเสา</th>
                <th>พิกัด</th>
                <th>การตรวจพบสัตว์</th>
                <th>การตรวจพบสัตว์</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td>{row.no}</td>
                  <td>{row.stationCode}</td>
                  <td>{row.stationName}</td>
                  <td>{row.coordinates}</td>
                  <td>
                    <span>
                      <UserStatus />
                    </span>
                  </td>
                  <td>
                    <img src={eye} onClick={() => handleDetailClick(row)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {activeDetail && (
        <Detail
          title="ตรวจจับสัตว์ป่า"
          weatherData={activeDetail}
          onClose={handleCloseDetail}
        >
          <label>พิกัด</label>
          <strong>###</strong>
        </Detail>
      )}
    </div>
  );
}
export default Wildlife;
